import { Map, View } from 'ol';
import { createContext, useContext } from 'react';
import * as control from 'ol/control';
import { EPSG25833 } from '@/components/map/map-utils/Projections';
import { geodataResolutions } from '@/components/map/map-utils/WebMapTileServices';
import { MapOptions } from 'ol/Map';

export interface MapContextValues {
    map: Map;
}

export const MapContext = createContext<MapContextValues>(undefined!);
export const MapProvider = MapContext.Provider;

export function createMap(center: [number, number], zoom: number): Map {
    const attribution = new control.Attribution({
        collapsible: false,
    });
    const scaleLineControl = new control.ScaleLine({
        units: 'metric',
        bar: true,
        text: true,
        minWidth: 140,
    });

    const options: MapOptions = {
        controls: control
            .defaults({ attribution: false })
            .extend([attribution, scaleLineControl]),
        layers: [],
        view: new View({
            center: [center[0], center[1]],
            extent: [-2200000, 5250000, 3300000, 8500000],
            maxZoom: 18,
            minZoom: 3,
            projection: EPSG25833,
            resolutions: geodataResolutions,
            zoom: zoom,
            constrainResolution: true,
        }),
    };

    return new Map(options);
}

export const useMap = () => useContext(MapContext);
